export const steps = {
    QUOTE_REQUEST: 'quoteRequest',
    REQUEST_SUCCESS: 'requestSuccess',
    PRE_QUOTE_DISPLAY: 'preQuoteDisplay',
};
